import { Content, Controls, Header, InfoGroup, ModalWrapper, UserInfo, Wrapper } from './card-user.styles';
import { CardUserProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { Photo } from '@shared/ui/photo/photo';
import { Tag } from '@shared/ui/tag/tag';

export const CardUser: React.FC<CardUserProps> = ({ user, children, isShowRole, ...props }) => {
    const clientName = userName({
        firstName: user.firstName,
        lastName: user.lastName,
        middleName: user.middleName,
    });

    return (
        <ModalWrapper>
            <Wrapper {...props}>
                <Header>
                    <UserInfo>
                        <Photo size='s' photoUrl={user.photoUrl} name={clientName.full} />
                        <Typography size='subtitle2' color='neutral_90'>
                            {clientName.full}
                        </Typography>
                    </UserInfo>
                </Header>
                <Content>
                    <InfoGroup $maxWidth={240}>
                        <Typography size='body2_long' color='neutral_50'>
                            Организация
                        </Typography>
                        <Typography size='body2_long'>{user.company?.shortName || '-'}</Typography>
                    </InfoGroup>
                    <InfoGroup $maxWidth={isShowRole ? 190 : 240}>
                        <Typography size='body2_long' color='neutral_50'>
                            Должность
                        </Typography>
                        <Typography size='body2_long'>{user.jobTitle}</Typography>
                    </InfoGroup>
                    <InfoGroup $maxWidth={isShowRole ? 269 : 369}>
                        <Typography size='body2_long' color='neutral_50'>
                            Департамент
                        </Typography>
                        <Typography size='body2_long'>{user.department?.name || '-'}</Typography>
                    </InfoGroup>
                    {isShowRole && (
                        <InfoGroup $maxWidth={150}>
                            <Typography size='body2_long' color='neutral_50'>
                                Роль
                            </Typography>
                            <Typography size='body2_long'>{user.role.roleName}</Typography>
                        </InfoGroup>
                    )}
                    <InfoGroup $maxWidth={199}>
                        <Typography size='body2_long' color='neutral_50'>
                            Верификация
                        </Typography>
                        <Tag variant={user.emailVerified ? 'green' : 'yellow'}>
                            {user.emailVerified ? 'Подтвержден' : 'В процессе активации'}
                        </Tag>
                    </InfoGroup>
                    <InfoGroup $maxWidth={120}>
                        <Typography size='body2_long' color='neutral_50'>
                            Статус
                        </Typography>
                        <Tag variant={user.active ? 'green' : 'red'}>{user.active ? 'Активен' : 'Заблокирован'}</Tag>
                    </InfoGroup>
                </Content>
            </Wrapper>
            <Controls>{children}</Controls>
        </ModalWrapper>
    );
};
